import { space } from "@artsy/palette"

export const NAV_BAR_BORDER_OFFSET = 1
export const NAV_BAR_TOP_TIER_HEIGHT = space(6) - NAV_BAR_BORDER_OFFSET
export const NAV_BAR_BOTTOM_TIER_HEIGHT = 44
export const NAV_BAR_HEIGHT =
  NAV_BAR_TOP_TIER_HEIGHT + NAV_BAR_BOTTOM_TIER_HEIGHT
export const MOBILE_NAV_HEIGHT = NAV_BAR_TOP_TIER_HEIGHT
